import { Link } from "react-router-dom";
import { Button } from "antd";
import { motion } from "motion/react";
import OurTeam from "./OurTeam";
import img1 from '../../assets/About1.jpg'
import img2 from '../../assets/About2.jpg'


const ease = [0.22, 1, 0.36, 1];

export default function About() {
  const features = [
    "Authentic Ayurvedic principles & holistic treatments",
    "Personalized diet & lifestyle consultations",
    "Serene environment & holistic therapies",
  ];

  return (
    <section className="py-24 bg-[#faf6ee] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* LEFT IMAGES */}
          <div className="md:flex relative hidden">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
              <motion.div
                initial={{ opacity: 0, x: -60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, ease }}
                className="mt-12"
              >
                <div className="overflow-hidden rounded-3xl shadow-2xl">
                  <motion.img
                    whileHover={{ scale: 1.08 }}
                    transition={{ duration: 0.6 }}
                    src={img1}
                    alt="image"
                    className="h-[340px] w-full object-cover"
                  />
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2, ease }}
              >
                <div className="overflow-hidden rounded-3xl shadow-2xl">
                  <motion.img
                    whileHover={{ scale: 1.08 }}
                    transition={{ duration: 0.6 }}
                    src={img2}
                    alt=""
                    className="h-[440px] w-full object-cover"
                  />
                </div>
              </motion.div>
            </div>

            {/* Floating Badge */}
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              className="absolute left-1/2 bottom-8 -translate-x-1/2 bg-brand-gold text-white rounded-3xl shadow-2xl px-8 py-5 text-center"
            >
              <h2 className="text-4xl font-bold text-white">8+</h2>
              <p className="text-sm uppercase tracking-wider text-white">Years Experience</p>
            </motion.div>
          </div>

          {/* RIGHT CONTENT */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease }}
          >
            <p className="uppercase md:text-xl text-base font-extrabold text-brand-gold mb-5">About Veda Nova</p>

            <h2 className="text-4xl lg:text-6xl font-bold text-brand-forest leading-tight mb-8">
              Rooted in Tradition,
              <br />
              Dedicated to Natural Healing.
            </h2>

             {/* Mobile screen images */}
             {/* LEFT IMAGES */}
          <div className="md:hidden relative mb-2">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
              <motion.div
                initial={{ opacity: 0, x: -60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, ease }}
                className="mt-4"
              >
                <div className="overflow-hidden w-[80%] rounded-3xl shadow-2xl">
                  <motion.img
                    whileHover={{ scale: 1.08 }}
                    transition={{ duration: 0.6 }}
                    src={img1}
                    alt="image"
                    className="h-[340px] w-full object-cover"
                  />
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, x: 60 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2, ease }}
              >
                <div className="overflow-hidden rounded-3xl shadow-2xl">
                  <motion.img
                    whileHover={{ scale: 1.08 }}
                    transition={{ duration: 0.6 }}
                    src={img2}
                    alt=""
                    className="h-[440px] w-full object-cover"
                  />
                </div>
              </motion.div>
            </div>

            {/* Floating Badge */}
            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              className="absolute left-1/2 bottom-8 -translate-x-1/2 bg-brand-gold text-white rounded-3xl shadow-2xl px-8 py-5 text-center"
            >
              <h2 className="text-4xl font-bold text-white">8+</h2>
              <p className="text-sm uppercase tracking-wider text-white">Years Experience</p>
            </motion.div>
          </div>

            <p className="text-gray-600 leading-8 mb-6">
              At Veda Nova, we believe true wellness comes from aligning the mind, body, and spirit. Our Ayurvedic
              experts combine ancient wisdom with modern healthcare practices to deliver holistic, personalized
              healing experiences.
            </p>

            <p className="text-gray-600 leading-8 mb-10">
              Every treatment is carefully designed to restore balance, strengthen immunity, and improve overall
              well-being through authentic Ayurvedic therapies.
            </p>

            {/* Statistics */}
            <div className="grid grid-cols-3 gap-6 mb-10">
              <div>
                <h3 className="text-4xl font-bold text-brand-gold">8+</h3>
                <p className="text-gray-500">Years</p>
              </div>
              <div>
                <h3 className="text-4xl font-bold text-brand-gold">500+</h3>
                <p className="text-gray-500">Patients</p>
              </div>
              <div>
                <h3 className="text-4xl font-bold text-brand-gold">94%</h3>
                <p className="text-gray-500">Success</p>
              </div>
            </div>

            {/* Features */}
            <div className="space-y-5 border-t pt-8">
              {features.map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex items-center gap-4"
                >
                  <div className="w-9 h-9 rounded-full bg-green-100 flex items-center justify-center text-green-700 font-bold">
                    ✓
                  </div>
                  <span className="text-brand-forest font-medium">{item}</span>
                </motion.div>
              ))}
            </div>

            {/* Button */}
            <Link to="/appointment">
              <Button
                type="primary"
                shape="round"
                size="large"
                className="mt-10 !bg-brand-forest hover:!bg-brand-gold !border-none !shadow-lg"
              >
                Book Consultation →
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
      {/* <OurTeam /> */}
    </section>
  );
}
